import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  // Lives on the frame's wrapper, not the frame: a stream-replaced frame keeps neither the
  // wiring nor a src, so it is refetched by re-setting src the way Turbo's own reload does.
  reload () {
    const frame = this.element.querySelector('turbo-frame')
    if (!frame) return

    frame.removeAttribute('complete')
    frame.src = null
    frame.src = this.urlValue
  }
}
